import HomeComponent from "../../views/HomeComponent"
import AboutComponent from "../../views/AboutComponent";
import ContactComponent from "../../views/ContactComponent";
import HostingComponent from "../../views/HostingComponent";
import VpsHostingComponent from "../../views/VpsHostingComponent";
import SharedHostingComponent from "../../views/SharedHostingComponent";
import TermsOfServiceComponent from "../../views/TermsOfServiceComponent";
import PrivacyPolicyComponent from "../../views/PrivacyPolicyComponent";

export const Routes = [
    {
        path: '/',
        name: "home",
        component: HomeComponent,
        meta:
            {
                requiresAuth: false, showInNav: true, title: "Home", isPrimary: true
            }
    },
    {
        path: '/hosting',
        name: "hosting",
        component: HostingComponent,
        meta:
            {
                requiresAuth: false, showInNav: false, title: "Industry Leading Hosting"
            }
    },
    {
        path: '/hosting/shared',
        name: 'hosting.shared',
        component: SharedHostingComponent,
        meta:
            {
                requiresAuth: false, showInNav: true, title: "Shared Hosting"
            }
    },
    {
        path: '/hosting/vps',
        name: 'hosting.vps',
        component: VpsHostingComponent,
        meta:
            {
                requiresAuth: false, showInNav: true, title: "VPS Hosting"
            }
    },
    {
        path: '/about',
        component: AboutComponent,
        name: "about",
        meta:
            {
                requiresAuth: false, showInNav: false, title: "Who We Are"
            }
    },
    {
        path: '/contact',
        component: ContactComponent,
        name: "contact",
        meta:
            {
                requiresAuth: false, showInNav: true, title: "Contact Us"
            }
    },
    {
        path: '/legal/tos',
        component: TermsOfServiceComponent,
        name: "tos",
        meta:
            {
                requiresAuth: false, showInNav: false, title: "Terms Of Service"
            }
    },
    {
        path: '/legal/privacy-policy',
        component: PrivacyPolicyComponent,
        name: "privacy-policy",
        meta:
            {
                requiresAuth: false, showInNav: false, title: "Privary Policy"
            }
    }
];